"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkOnetoone = void 0;
var DEFAULT_ONETOONE = 100;
var checkOnetoone = function (rotations, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var repeats = [];
    var onetoone = options.onetoone || DEFAULT_ONETOONE;
    for (var i = 0; i < rotations.length; i++) {
        var j = i + 1;
        if (rotations[i].mediafileType !== 0)
            continue;
        while (j < rotations.length && j - i < onetoone) {
            if (((_a = rotations[i].mediafile) === null || _a === void 0 ? void 0 : _a.id) === ((_b = rotations[j].mediafile) === null || _b === void 0 ? void 0 : _b.id)) {
                repeats.push({
                    first: rotations[i].id,
                    second: rotations[j].id,
                    distance: j - i,
                });
                break;
            }
            j += 1;
        }
    }
    return repeats;
};
exports.checkOnetoone = checkOnetoone;
//# sourceMappingURL=checkOnetoone.js.map